// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scroll-content {
  overflow: hidden;
}

.close-btn {
  background: transparent;
  box-shadow: none;
}

.close-btn:hover:not(.disable-hover) {
  background: transparent;
}

#closeIcon {
  color: white !important;
  font-size: 30px;
  margin: 0 auto;
  background: transparent;
  box-shadow: none;
  font-weight: bold;
}

.actionButton {
  color: #ffffff;
  border-radius: 4px;
  font-size: 14px;
}

.row-style {
  margin: 0px 3% 0px 3%;
}

.labelFont {
  font-size: smaller;
  margin-bottom: 0px !important;
}

.signInImage {
  height: 100px;
}

.header-row {
  height: 150px;
}

.sendBtn {
  width: 100%;
  height: 2.8em;
  margin-top: 8px;
}

.form-style {
  margin-bottom: 2%;
}

.grid-align {
  margin-top: 90px;
}

.error-text {
  height: auto;
  text-align: left;
  font-size: 14px;
  margin-top: 5px;
  margin-bottom: 0px;
}

.yellow {
  color: yellow;
}

.scroll-content {
  overflow: hidden;
}

.close-btn {
  background: transparent;
  box-shadow: none;
}

.close-btn:hover:not(.disable-hover) {
  background: transparent;
}

#closeIcon {
  color: white !important;
  font-size: 30px;
  margin: 0 auto;
  background: transparent;
  box-shadow: none;
  font-weight: bold;
}

.actionButton {
  color: #ffffff;
  border-radius: 4px;
  font-size: 14px;
}

#forgetPasswordForm,
#successMessage {
  padding: 35px;
  min-width: 100px;
  max-width: 400px;
  margin: 0 auto;
  background: rgba(0, 0, 0, 0.47);
  border: 1px solid transparent;
  margin-top: calc(5% + env(safe-area-inset-top)) !important;
}

#titleHeader {
  color: #d9e7f1;
  font-size: 20px;
  text-align: center;
}

.inputField {
  margin-top: 40px;
}

ion-input {
  margin-top: 8px;
  border-radius: 2px;
  height: 40px;
  color: #000000;
  font-size: 14px;
  background: white;
}

ion-button::part(native) {
  left: -2px;
}`, "",{"version":3,"sources":["webpack://./src/app/forgot-password/forgot-password.page.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;AACJ;;AAEE;EACE,uBAAA;EACA,gBAAA;AACJ;;AAEE;EACE,uBAAA;AACJ;;AAEE;EACE,uBAAA;EACA,eAAA;EACA,cAAA;EACA,uBAAA;EACA,gBAAA;EACA,iBAAA;AACJ;;AAEE;EACE,cAAA;EACA,kBAAA;EACA,eAAA;AACJ;;AAEE;EACE,qBAAA;AACJ;;AAEE;EACE,kBAAA;EACA,6BAAA;AACJ;;AAEE;EACE,aAAA;AACJ;;AAEE;EACE,aAAA;AACJ;;AAEE;EACE,WAAA;EACA,aAAA;EACA,eAAA;AACJ;;AAEE;EACE,iBAAA;AACJ;;AAEE;EACE,gBAAA;AACJ;;AAEE;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;AACJ;;AAEE;EACE,aAAA;AACJ;;AAEE;EACE,gBAAA;AACJ;;AAEE;EACE,uBAAA;EACA,gBAAA;AACJ;;AAEE;EACE,uBAAA;AACJ;;AAEE;EACE,uBAAA;EACA,eAAA;EACA,cAAA;EACA,uBAAA;EACA,gBAAA;EACA,iBAAA;AACJ;;AAEE;EACE,cAAA;EACA,kBAAA;EACA,eAAA;AACJ;;AAEE;;EAEE,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,+BAAA;EACA,6BAAA;EACA,0DAAA;AACJ;;AAEE;EACE,cAAA;EACA,eAAA;EACA,kBAAA;AACJ;;AAEE;EACE,gBAAA;AACJ;;AAEE;EACE,eAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AACJ;;AAEE;EACE,UAAA;AACJ","sourcesContent":[".scroll-content {\n    overflow: hidden;\n  }\n  \n  .close-btn {\n    background: transparent;\n    box-shadow: none;\n  }\n  \n  .close-btn:hover:not(.disable-hover) {\n    background: transparent;\n  }\n  \n  #closeIcon {\n    color: white !important;\n    font-size: 30px;\n    margin: 0 auto;\n    background: transparent;\n    box-shadow: none;\n    font-weight: bold;\n  }\n  \n  .actionButton {\n    color: #ffffff;\n    border-radius: 4px;\n    font-size: 14px;\n  }\n  \n  .row-style {\n    margin: 0px 3% 0px 3%;\n  }\n  \n  .labelFont {\n    font-size: smaller;\n    margin-bottom: 0px !important;\n  }\n  \n  .signInImage {\n    height: 100px;\n  }\n  \n  .header-row {\n    height: 150px;\n  }\n  \n  .sendBtn {\n    width: 100%;\n    height: 2.8em;\n    margin-top: 8px;\n  }\n  \n  .form-style {\n    margin-bottom: 2%;\n  }\n  \n  .grid-align {\n    margin-top: 90px;\n  }\n  \n  .error-text {\n    height: auto;\n    text-align: left;\n    font-size: 14px;\n    margin-top: 5px;\n    margin-bottom: 0px;\n  }\n  \n  .yellow {\n    color: yellow;\n  }\n  \n  .scroll-content {\n    overflow: hidden;\n  }\n  \n  .close-btn {\n    background: transparent;\n    box-shadow: none;\n  }\n  \n  .close-btn:hover:not(.disable-hover) {\n    background: transparent;\n  }\n  \n  #closeIcon {\n    color: white !important;\n    font-size: 30px;\n    margin: 0 auto;\n    background: transparent;\n    box-shadow: none;\n    font-weight: bold;\n  }\n  \n  .actionButton {\n    color: #ffffff;\n    border-radius: 4px;\n    font-size: 14px;\n  }\n  \n  #forgetPasswordForm,\n  #successMessage {\n    padding: 35px;\n    min-width: 100px;\n    max-width: 400px;\n    margin: 0 auto;\n    background: rgba(0, 0, 0, 0.47);\n    border: 1px solid transparent;\n    margin-top: calc(5% + env(safe-area-inset-top)) !important;\n  }\n  \n  #titleHeader {\n    color: #d9e7f1;\n    font-size: 20px;\n    text-align: center;\n  }\n  \n  .inputField {\n    margin-top: 40px;\n  }\n  \n  ion-input {\n    margin-top: 8px;\n    border-radius: 2px;\n    height: 40px;\n    color: #000000;\n    font-size: 14px;\n    background: white;\n  }\n  \n  ion-button::part(native) {\n    left: -2px;\n  }\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
